import { formatearFechaLuxon } from "../../utils/formatearFecha"
import PagoSinFactura from "../domain/PagoSinfactura"
import ApiServiceAdapter from "../infraestructure/ApiServiceAdapter"

class PagosSinFacturaService {
  constructor() {
    this.apiService = new ApiServiceAdapter()
  }


  async getListPagos(idLiquidacion, fechaVtoInicio, fechaVtoFin, fechaAltaInicio, fechaAltaFin,
    idJuicio, monImporteFacDesde, monImporteFacHasta, cuitLetrado) {

    let listadoPagos

    try {
      const idLiquidacionWeb = (idLiquidacion == -2 || idLiquidacion == -1) ? undefined : idLiquidacion
      const cuitLetradoFormateado = cuitLetrado === undefined ? "" : cuitLetrado
      const fechaVtoInicioformateada = fechaVtoInicio ? formatearFechaLuxon(fechaVtoInicio, 'yyyy-MM-dd') : ""
      const fechaVtoFinformateada = fechaVtoFin ? formatearFechaLuxon(fechaVtoFin, 'yyyy-MM-dd') : ""
      const fechaAltaInicioformateada = fechaAltaInicio ? formatearFechaLuxon(fechaAltaInicio, 'yyyy-MM-dd') : ""
      const fechaAltaFinformateada = fechaAltaFin ? formatearFechaLuxon(fechaAltaFin, 'yyyy-MM-dd') : ""
      const idJuicioFormateado = (idJuicio == -2 || idJuicio == -1) ? undefined : idJuicio

      const pagosData = await this.apiService.fetchPagosSinFactura(idLiquidacionWeb, cuitLetradoFormateado, idJuicioFormateado, fechaVtoInicioformateada, fechaVtoFinformateada, fechaAltaInicioformateada, fechaAltaFinformateada, monImporteFacDesde, monImporteFacHasta)

      listadoPagos = !pagosData ? [] : pagosData.map(
        (liq) =>
          new PagoSinFactura(
            liq.idLiquidacionWeb,
            liq.fechaRegistro,
            formatearFechaLuxon(liq.fechaRegistro, 'dd/MM/yyyy'),
            liq.fechaVto, 
            formatearFechaLuxon(liq.fechaVto, 'dd/MM/yyyy'),
            liq.nroRecibo,
            liq.caratulaJuicio,
            liq.formaPago,
            liq.importe,
            liq.idJuicio
          ))
    } catch (err) {
      listadoPagos = []
    }

    return listadoPagos
  }


  async altaPagoSinFactura(datos) {
    let resultado

    try {
      const payload = {
        fechaVto: datos.fechaVto,
        cuitLetrado: datos.cuitLetrado,
        idJuicio: datos.idJuicio,
        idDenuncia: datos.idDenuncia,
        importeTotal: datos.importeTotal,
        idUsuarioAlta: datos.idUsuarioAlta,
        pagos: datos.pagos?.map(pago => ({
          idKey: pago.idKey,
          importeTotal: pago.importeTotal,
          fechaVto: pago.fechaVto,
          formaPago: {
            idKey: 0,
            importeTotal: pago.importeTotal,
            descripcionPago1: pago.formaPago?.descripcionPago1 || null,
            descripcionPago2: pago.formaPago?.descripcionPago2 || null,
            forma: pago.formaPago?.forma
              ? { id: pago.formaPago.forma.id, label: pago.formaPago.forma.label }
              : null,
            subForma: pago.formaPago?.subforma
              ? { id: pago.formaPago.subforma.id, label: pago.formaPago.subforma.label }
              : null
          },
          conceptosLiq: pago.conceptosLiq?.map(c => ({
            idConcepto: c.idconcepto,
            importe: c.importe
          })) || null
        })) || []
      }
      resultado = await this.apiService.fetchAltaPago(payload)
    } catch (err) {
      resultado = { message: 'ERROR' }
    }
    return resultado
  }
  async getDetallePago(idLiquidacion) {

    let listadoPagos

    try {

      const pagosData = await this.apiService.fetchDetallePagosSinFactura(idLiquidacion)

      listadoPagos = pagosData
      
    } catch (err) {
      listadoPagos = []
    }

    return listadoPagos
  }

  async getFormasPago() {
    let listadoFormaPagos
    try {
      const formapagoData = await this.apiService.fetchFormaPago()
      listadoFormaPagos = formapagoData      
    } catch (err) {
      listadoFormaPagos = []
    }
    return listadoFormaPagos
  }
  
  async getDetalleFormaPago() {
    let listadoFormaPagosDetalle
    try {
      const detalleFormaPago = await this.apiService.fetchDetalleFormaPago()
      listadoFormaPagosDetalle = detalleFormaPago
      
    } catch (err) {
      listadoFormaPagosDetalle = []
    }
    return listadoFormaPagosDetalle
  }

}

export default PagosSinFacturaService